export const filterOutById = <T extends { id: any }>(id: T['id']) => {
  return (data: T[] | undefined) => data?.filter(item => item.id !== id);
};

export const safeOffset = (offset: string | number) => {
  offset = String(offset);
  return offset === '0' ? undefined : offset;
};
